import { render, staticRenderFns } from "./WindowsMinimizeIcon.vue?vue&type=template&id=093bec0e&"
import script from "./WindowsMinimizeIcon.vue?vue&type=script&lang=js&"
export * from "./WindowsMinimizeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports